export default {
  namespaced: true,

  state: () => ({
    faqs: {
      data: [],
      links: {},
      meta: {},
    },
    faq: {},
    isLoading: false,
  }),

  getters: {},

  mutations: {
    SET_FAQ_LIST(state, payload) {
      state.faqs = payload
    },
    SET_FAQ(state, payload) {
      state.faq = payload
    },
    SET_LOADING(state, value) {
      state.isLoading = value
    },
  },

  actions: {
    async getFaqs({ commit }, { page = null } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = '/v1/admin/faqs'

        const response = await this._vm.$http.get(url, { params: { page } })

        commit('SET_FAQ_LIST', response.data)

        commit('SET_LOADING', false)
        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    async deleteFaq({ commit, dispatch }, { faqId }) {
      try {
        const url = `/v1/admin/faqs/${faqId}`

        const response = await this._vm.$http.delete(url)

        dispatch('getFaqs')

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus FAQ!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menghapus FAQ!',
        }, { root: true })

        return error
      }
    },
    async createFaq({ commit }, data) {
      try {
        const url = '/v1/admin/faqs'
        const response = await this._vm.$http.post(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan FAQ!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan FAQ!',
        }, { root: true })

        return error
      }
    },
    async getFaq({ commit }, { id }) {
      try {
        const url = `/v1/admin/faqs/${id}`

        const response = await this._vm.$http.get(url)

        commit('SET_FAQ', response.data)

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        return error
      }
    },
    async updateFaq({ commit }, { faqId, data }) {
      try {
        const url = `/v1/admin/faqs/${faqId}`
        const response = await this._vm.$http.put(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah FAQ!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah FAQ!',
        }, { root: true })

        return error
      }
    },
    async updateStatus({ commit }, {
      faqId, data, element = '', value,
    }) {
      try {
        const dataForm = data

        if (element === 'highlight') {
          dataForm.is_highlighted = value
        } else {
          dataForm.is_active = value
        }

        const url = `/v1/admin/faqs/${faqId}`
        const response = await this._vm.$http.put(url, dataForm)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah FAQ!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah FAQ!',
        }, { root: true })

        return error
      }
    },
  },
}
